import type { VirtualElementNodeAttributes, VirtualNode } from './types';
import { VirtualNodeCollectionRenderer } from './VirtualNodeCollectionRenderer';
import type { VirtualRendererOptions } from './VirtualRenderer';

type Props = {
  options: VirtualRendererOptions;
  node: VirtualNode;
};

export const VirtualNodeRenderer = ({ node, options }: Props) => {
  if (typeof node === 'string') {
    return <>{node}</>;
  }

  if (options.allowedNodeTypes.includes(node.type)) {
    const Tag: string = node.type;

    const allowedAttributes: readonly string[] = Object.keys(
      node.attributes
    ).filter((attr: string) => options.allowedAttributes.includes(attr));

    const attributes: { [attr: string]: any } = {};

    for (const attr of allowedAttributes) {
      attributes[attr] = node.attributes[attr];
    }

    return (
      <Tag {...(attributes as VirtualElementNodeAttributes)}>
        <VirtualNodeCollectionRenderer
          nodes={node.children}
          options={options}
        />
      </Tag>
    );
  }

  return null;
};
